import { Slot } from '@radix-ui/react-slot';
import * as React from 'react';
import { cn } from 'src/app/lib/utils/tailwindcss';

export type BaseBadgeProps = React.ComponentProps<'div'> & {
  asChild?: boolean;
};

function BaseBadge({ className, asChild = false, ...props }: BaseBadgeProps) {
  const Comp = asChild ? Slot : 'div';

  return <Comp className={cn(className)} {...props} />;
}

export default BaseBadge;
